import { render, staticRenderFns } from "./IndustryNews.vue?vue&type=template&id=956d6f66&scoped=true&"
import script from "./IndustryNews.vue?vue&type=script&lang=js&"
export * from "./IndustryNews.vue?vue&type=script&lang=js&"
import style0 from "./IndustryNews.vue?vue&type=style&index=0&id=956d6f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956d6f66",
  null
  
)

export default component.exports